<style scoped>
    .control-label {
        height: 34px;
        line-height: 34px;
        font-size: 1.2em;
        color: #656D78;
        font-weight: normal;
    }

    .input-inner-icon {
        font-size: 22px;
        position: absolute;
        color: #CCD1D9;
        left: 25px;
        height: 46px;
        line-height: 46px;
    }

    .input-inner-icon.sm {
        font-size: 16px;
    }

    .input-lg {
        padding-left: 40px;
    }
</style>
<template>
    <modal :show.sync="showModal" :backdrop="false">
        <div slot="modal-header" class="modal-header">
            <h4 class="modal-title">
                <i class="fa fa-meh-o fa-fw"></i>会话失效啦，您需要重新登录以继续操作
            </h4>
        </div>
        <div slot="modal-body" class="modal-body pt20 pb20">
            <form class="form-horizontal">
                <div class="form-group">
                    <label class="col-sm-2 control-label">帐&emsp;号</label>
                    <div class="col-sm-8">
                        <i class="fa fa-envelope input-inner-icon sm"></i>
                        <input class="form-control input-lg" readonly v-model="employerAcct">
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-sm-2 control-label">密&emsp;码</label>
                    <div class="col-sm-8">
                        <i class="fa fa-lock input-inner-icon"></i>
                        <input type="password" class="form-control input-lg" v-model="password" placeholder="密码">
                    </div>
                </div>
                <div class="form-group mt20">
                    <div class="col-sm-offset-2 col-sm-8">
                        <a class="btn btn-success btn-lg btn-block center-block"
                           @click="login">重新登录</a>
                    </div>
                </div>
            </form>
        </div>
        <div slot="modal-footer" class="modal-footer none">
        </div>
    </modal>
</template>
<script lang="babel">
    let errCount = 0 // 登录失败3次跳转至登录页面
    import msg from 'bootsets/components/msg'
    import modal from 'bootsets/components/modal'
    import {user} from 'bootsets/runtime'
    import {accountModel} from 'bootsets/models'
    export default {
        data() {
            return {
                employerAcct: user.username,
                showModal: false,
                password: ''
            }
        },
        components: {modal},
        events: {
            show() {
                this.showModal = true
            }
        },
        methods: {
            login() {
                if (!this.password) {
                    msg.warning('请输入密码')
                    return
                }
                accountModel.login(this.employerAcct, this.password).then(() => {
                    this.showModal = false
                    this.$dispatch('close')
                }, (err) => {
                    errCount++
                    if (errCount >= 3) {
                        window.location.href = '/login'
                    } else {
                        msg.danger(err)
                    }
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// re-login.vue?6c28440e